import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { LoadingSpinner } from '../atoms/LoadingSpinner';
import { PsTransferViewContent } from '../organisms/ps-transfer/PsTransferViewContent';

class PsTransferView extends React.Component {
    state = {
        po: null,
        isLoaded: false,
        error: null
    };

    componentDidMount() {
        this._loadPo();
    }

    componentDidUpdate(prevProps) {
        const prevPoRef = prevProps.match && prevProps.match.params && prevProps.match.params.poRef;
        const currentPoRef = this.props.match && this.props.match.params && this.props.match.params.poRef;
        if (prevPoRef !== currentPoRef) {
            this._loadPo();
        }
    }

    _loadPo = () => {
        const { client, match } = this.props;
        const poRef = match && match.params && match.params.poRef;

        if (!poRef) {
            this.setState({
                error: new Error('No PO reference provided'),
                isLoaded: true
            });
            return;
        }

        this.setState({ isLoaded: false, error: null });

        client.purchaseOrders.getPurchaseOrderByRef(poRef)
            .then(po => {
                this.setState({
                    po,
                    isLoaded: true
                });
            })
            .catch(error => {
                this.setState({
                    error,
                    isLoaded: true
                });
            });
    };

    render() {
        const { client, productsClient } = this.props;
        const { po, isLoaded, error } = this.state;

        if (error) {
            return (
                <Container fluid className="mt-3">
                    <div className="text-danger">
                        Error loading PO: {error.message}
                    </div>
                </Container>
            );
        }

        if (!isLoaded) {
            return (
                <Container fluid className="mt-3">
                    <LoadingSpinner />
                </Container>
            );
        }

        return (
            <Container fluid className="mt-3">
                <PsTransferViewContent
                    po={po}
                    client={client}
                    productsClient={productsClient}
                    onPoUpdated={this._loadPo}
                />
            </Container>
        );
    }
}

PsTransferView.propTypes = {
    client: PropTypes.object.isRequired,
    productsClient: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            poRef: PropTypes.string
        })
    }).isRequired
};

export { PsTransferView };
